export const styleSheet = () => ({
  root: {
    minHeight: "100vh",
    padding: "20px 0px",
  },
  agentActivitiesScreenTopArea: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  agentActivitiesScreenTopFilter: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  agentActivitiesReportHeading: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    fontFamily: "AvenirNext  !important",
  },
  agentActivitiesChartGraph: {
    background: "white",
    margin: "25px 0px",
    minHeight: "250px",
    padding: "15px",
  },
  agentActivitiesStatContent: {
    fontSize: "12px !important",
    fontWeight: "500 !important",
    fontFamily: "AvenirNext  !important",
    textTransform: "uppercase",
    whiteSpace: "nowrap !important",
  },
  agentActivitiesStatValue: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    fontFamily: "AvenirNext  !important",
  },
  agentActivitiesStatsArea: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px !important",
  },
  graphBottomDates: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .MuiTypography-root": {
      fontSize: "12px !important",
      fontWeight: "500 !important",
      fontFamily: "AvenirNext  !important",
    },
  },
  agentActivitiesStatsItem: {
    width: "275px",
    height: "70px",
    background: "white",
    cursor: "pointer",
  },
  agentActivitiesStatsItemTop: {
    padding: "10px",
    paddingBottom: "37.8px",
  },
  exportButton: {
    border: "1px solid rgb(215, 222, 226) !important",
    borderRadius: "4px",
    background: "linear-gradient(rgb(255, 255, 255), rgb(232, 236, 240))",
    color: "rgb(109, 130, 145) !important",
    fontSize: "12px !important",
    fontWeight: "500 !important",
    fontFamily: "AvenirNext  !important",
    textTransform: "capitalize  !important",
    marginRight: "15px !important",
    padding: "6px 10px !important",
    minWidth: "40px !important",
  },
  listItemForSelection: {
    height: "40px !important",
    "& 	.MuiListItemText-primary": {
      fontSize: "12px !important",
      fontWeight: "500 !important",
      fontFamily: "AvenirNext  !important",
      color: "#9FB1BF !important",
    },
    "& .MuiListItemText-secondary": {
      fontSize: "12px !important",
      fontWeight: "500 !important",
      fontFamily: "AvenirNext  !important",
    },
  },
  tableRoot: {
    height: "calc(100vh - 140px)",
    width: "100%",
    backgroundColor: "white",
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    // Force hardware acceleration
    transform: 'translate3d(0,0,0)',
    // Ensure proper stacking context
    zIndex: 0,
    
    // Container specific styles
    '& .MuiDataGrid-root': {
      border: 'none',
      height: '100%',
      width: '100%',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column'
    },
    
    // Ensure content doesn't collapse
    '& .MuiDataGrid-main': {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      minHeight: 0,
      minWidth: 0
    },
    
    // Ensure proper scrollbar display
    '& .MuiDataGrid-virtualScroller': {
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '8px',
        display: 'block !important'
      },
      '&::-webkit-scrollbar-track': {
        backgroundColor: '#F5F5F5'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888'
      },
      // Ensure proper spacing for horizontal scrollbar
      marginBottom: '56px'
    },
    
    // Footer positioning
    '& .MuiDataGrid-footerContainer': {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
      backgroundColor: 'white'
    }
  },
  toggleSection: {
    marginBottom: "10px",
  },
});
